import { defineMessages, type IntlShape } from 'react-intl';

const genderLabelMessages = defineMessages({
  male: {
    defaultMessage: 'Male',
    id: 'Ry21biqzmR',
    description:
      'Patient gender label shown in patient demographic lines (suggested matches, session-merge review)',
  },
  female: {
    defaultMessage: 'Female',
    id: '6GUEgFuyhe',
    description:
      'Patient gender label shown in patient demographic lines (suggested matches, session-merge review)',
  },
});

/**
 * Normalizes a patient gender value to a localized display label.
 *
 * Accepts both the structured `shared__enums__enums__Gender` enum (patient profiles)
 * and the free-text `gender` string on the session's embedded patient, since
 * legacy data can carry abbreviations. Mirrors Android's shared
 * `PatientGenderDisplay` classification so the platforms render the
 * same label:
 *
 * - `female` / `f` → localized "Female"
 * - `male` / `m` → localized "Male"
 * - `unknown` / `un` / `u` / blank → `undefined` (hidden)
 * - anything else is passed through as-is (trimmed) — arbitrary free text
 *   can't be pre-translated
 */
export function toGenderLabel(
  gender: string | null | undefined,
  intl: IntlShape
): string | undefined {
  const trimmed = gender?.trim();
  if (!trimmed) return undefined;

  switch (trimmed.toLowerCase()) {
    case 'f':
    case 'female':
      return intl.formatMessage(genderLabelMessages.female);
    case 'm':
    case 'male':
      return intl.formatMessage(genderLabelMessages.male);
    case 'u':
    case 'un':
    case 'unknown':
      return undefined;
    default:
      return trimmed;
  }
}
